<article class="card" [class.card--popup]="popup()">
  <!-- app-swipe-horizontal: swipe táctil del carrusel, además de las flechas
       (RP-11). Con una sola foto la directiva queda apagada. -->
  <div
    class="card__media"
    app-swipe-horizontal
    [swipeDeshabilitado]="!tieneVarias()"
    (swipe)="mover($event)"
  >
    <button
      type="button"
      class="card__foto-btn"
      (click)="verFicha()"
      [attr.aria-label]="'Ver ficha de ' + propiedad().direccion"
    >
      <app-foto-propiedad
        [fuentes]="fuentesFotoActual()"
        [alt]="altFoto()"
        placeholder="marca"
      />
    </button>

    @if (propiedad().emprendimiento) {
      <span class="card__emprendimiento">Emprendimiento</span>
    }

    <!-- Carrusel: sólo con más de una foto (ver el JSDoc del componente). -->
    @if (tieneVarias()) {
      <button
        type="button"
        class="card__flecha card__flecha--izq"
        (click)="anterior($event)"
        aria-label="Foto anterior"
      >
        <svg app-icono nombre="caret-left"></svg>
      </button>
      <button
        type="button"
        class="card__flecha card__flecha--der"
        (click)="siguiente($event)"
        aria-label="Foto siguiente"
      >
        <svg app-icono nombre="caret-right"></svg>
      </button>
    }

    <!-- Pestañas ancladas abajo a la derecha de la foto (Figma 244:1572).
         Con venta y alquiler van los dos precios (FP-49): el alquiler a la
         izquierda y la venta a la derecha, debajo del logo. -->
    <div class="card__pestanias" [class.card__pestanias--doble]="!!precioAlquiler()">
      @if (precioAlquiler(); as alquiler) {
        <div class="card__precio" title="Alquiler">
          <span class="card__precio-doblez" aria-hidden="true"></span>
          <span class="card__solo-lectores">Alquiler:</span>
          <span class="card__precio-texto">{{ alquiler }}</span>
        </div>
      }
      <div class="card__pestanias-col">
        @if (logoInmobiliaria(); as logo) {
          <div class="card__logo">
            <img [src]="logo" alt="" loading="lazy" />
          </div>
        }
        <div class="card__precio" [attr.title]="precioAlquiler() ? 'Venta' : null">
          <span class="card__precio-doblez" aria-hidden="true"></span>
          @if (precioAlquiler()) {
            <span class="card__solo-lectores">Venta:</span>
          }
          <span class="card__precio-texto">{{ precio() }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="card__cuerpo">
    <div class="card__ubicacion">
      <span class="card__localidad">{{ propiedad().localidad }}</span>
      <span class="card__direccion">| {{ propiedad().direccion }}</span>
    </div>

    <span class="card__divider" aria-hidden="true"></span>

    <div class="card__datos">
      <p class="card__detalles">{{ detalles() }}</p>

      @if (linkWhatsApp(); as link) {
        <a
          class="card__wsp"
          [href]="link"
          target="_blank"
          rel="noopener"
          aria-label="Consultar por WhatsApp"
          (click)="$event.stopPropagation()"
        >
          <svg app-icono nombre="whatsapp"></svg>
        </a>
      }
    </div>
  </div>
</article>
